import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  logo: '/img/logos/vans/loyalty.svg'
} satisfies RecursivePartial<CheckoutConfig['loyalty']>
